import {useEffect} from 'react'
import {StyleSheet, View} from 'react-native'
import {Trans, useLingui} from '@lingui/react/macro'

import {hasNavigatedInApp} from '#/lib/navigation/inAppNavigation'
import {ROUTES} from '#/lib/routes/constants'
import {navigateTo} from '#/lib/routes/helpers'
import {useSession} from '#/state/session'
import {atoms as a} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {TimesLarge_Stroke2_Corner0_Rounded as XIcon} from '#/components/icons/Times'
import {Text} from '#/components/Typography'
import {useExternalEntryPromptShown} from '#/storage/hooks/external-entry-prompt'
import {useSemanticTokens} from '#/wsocial/service/design-system'

function isAuthRoute() {
  const {pathname, search} = window.location
  return (
    pathname === '/onboarding' ||
    (pathname === ROUTES.LOGIN &&
      new URLSearchParams(search).get('login') === 'true')
  )
}

export function ExternalEntrySignupBanner() {
  const s = useSemanticTokens()
  const {t: l} = useLingui()
  const {hasSession} = useSession()
  const [shown, setShown] = useExternalEntryPromptShown()
  const onAuthRoute = isAuthRoute()

  useEffect(() => {
    if (onAuthRoute && !shown) setShown(true)
  }, [onAuthRoute, shown, setShown])

  if (hasSession || shown || hasNavigatedInApp() || onAuthRoute) return null

  const dismiss = () => setShown(true)

  const onJoin = () => {
    setShown(true)
    navigateTo(ROUTES.SIGNUP)
  }

  return (
    <View
      style={[
        styles.container,
        a.flex_row,
        a.align_center,
        a.justify_between,
        a.gap_md,
        a.px_xl,
        a.py_md,
        {
          backgroundColor: s.bg.default,
          borderColor: s.border.default,
          borderTopWidth: 2,
        },
      ]}>
      <Text
        style={[a.text_sm, a.font_bold, a.flex_1, {color: s.text.default}]}
        numberOfLines={2}>
        <Trans>Join W Social and connect with the world</Trans>
      </Text>

      <Button
        label={l`Create account`}
        onPress={onJoin}
        size="small"
        color="primary">
        <ButtonText>
          <Trans>Join now</Trans>
        </ButtonText>
      </Button>

      <Button
        label={l`Dismiss`}
        onPress={dismiss}
        size="tiny"
        variant="ghost"
        shape="round"
        style={[a.bg_transparent]}>
        <XIcon size="xs" style={[{color: s.text.default}]} />
      </Button>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'fixed' as 'absolute', // ponytail: web-only fixed positioning
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
  },
})
